import {
  SECTION_HOMEPAGE,
  SECTION_CATEGORY,
  SECTION_POST_LIST,
  SECTION_MY_POSTS,
  getBundleName,
  SECTION_RELATED_POSTS,
  type Section,
} from '@wix/communities-blog-client-common';
import { MY_POSTS_PAGE_BUNDLE_NAME } from '../../my-posts-page/constants/my-posts-page';
import { POST_LIST_WIDGET_BUNDLE_NAME } from '../../post-list-widget/constants/post-list-widget';
import { RELATED_POSTS_WIDGET_BUNDLE_NAME } from '../../related-posts-widget/constants/related-posts-widget';
import { getRoute } from '../router/router-selectors';
import {
  isInFeed,
  isInCategory,
  isInTags,
  isInArchivePage,
  isInHashtagPage,
  isInPostPage,
} from '../services/detect-route';
import { type AppState } from '../types';

export function getSection(state: AppState): Section | undefined;
export function getSection(state: AppState, fallbackEnabled: true): Section;
export function getSection(state: AppState, fallbackEnabled: boolean): Section | undefined;
export function getSection(state: AppState, fallbackEnabled?: boolean) {
  const route = getRoute(state);
  if (isInFeed(route)) {
    return SECTION_HOMEPAGE;
  }

  if (isInCategory(route) || isInTags(route) || isInArchivePage(route) || isInHashtagPage(route)) {
    return SECTION_CATEGORY;
  }

  if (getBundleName(state) === POST_LIST_WIDGET_BUNDLE_NAME) {
    return SECTION_POST_LIST;
  }

  if (getBundleName(state) === RELATED_POSTS_WIDGET_BUNDLE_NAME) {
    return SECTION_RELATED_POSTS;
  }

  if (getBundleName(state) === MY_POSTS_PAGE_BUNDLE_NAME) {
    return SECTION_MY_POSTS;
  }

  if (isInPostPage(route)) {
    return undefined;
  }

  return fallbackEnabled ? SECTION_CATEGORY : undefined;
}
